import { Heading, ButtonRow, Button } from "cai-fusion"
import { useNavigate } from "react-router-dom";

import GIFAnimationReading from "../../../../images/animation-reading-doc.gif"

const SiftProcessingUpload = () => {

    const navigate = useNavigate();
    
    return (
        <div className="o-page-section o-page-section l-pt-none">
            <div className="o-page-section__content-container o-page-section__content-container--extra-narrow l-pt-none l-mt-neg-sm">
                <div className="l-row l-pt-sm">
                    <div className="col-md-12 text-center">
                        <img src={GIFAnimationReading} className="a-responsive-image l-mb-sm" style={{width: "128px"}}/>
                        <Heading size={1}>Creating Opportunity</Heading>
                        <p className="a-medium-text a-muted-text">
                            Sift is reviewing the documents you've provided and creating a profile for the opportunity. 
                            It should be ready in 5-10 minutes. Feel free create another opportunity in the meantime.
                        </p>
                        <div className="row">
                            <div className="col-md-12">
                                <ButtonRow className="m-button-row--centered l-mt-sm">
                                    <Button 
                                        onClick={() => navigate(`/${process.env.REACT_APP_BRANDING_SIFT_PATH ?? "sift"}`)}
                                        children="Return to Opportunity List" 
                                        outline 
                                    />
                                    <Button 
                                        onClick={() => navigate(`/${process.env.REACT_APP_BRANDING_SIFT_PATH ?? "sift"}/opportunities/new`)}
                                        children="Create Another Opportunity" 
                                    />
                                </ButtonRow>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SiftProcessingUpload;